export const convertNames = {
  originalPassword: 'typePw',
  newPassword: 'newPw',
  repeatPassword: 'repeatPw',
};
